export default __webpack_public_path__ + "static/observatory-2b13f2b4aebfe12d5b921f46ee280de5.webp";